<template>
	<div class="move">
		<p class="move__desc">선택된 리뷰를 어느 제품으로 이동하시겠어요?</p>
		<product-selector v-model="selectedId" />
		<div class="btn-wrap-main">
			<button class="btn-main blue bordered" @click="close">닫기</button>
			<button class="btn-main blue" @click="batch">이동</button>
		</div>
		<table class="table-main move__table">
			<thead>
				<tr>
					<th colspan="3">
						이동시킬 제품(A)과 이동될 제품(B)에 동일한 유저의 리뷰가
						있는 경우
					</th>
				</tr>
				<tr>
					<th>A</th>
					<th>B</th>
					<th>처리방식</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>정상</td>
					<td>정상</td>
					<td>유지</td>
				</tr>
				<tr>
					<td>블라인드, 검수중</td>
					<td>정상</td>
					<td>유지</td>
				</tr>
				<tr>
					<td>블라인드</td>
					<td>검수중</td>
					<td>유지</td>
				</tr>
				<tr>
					<td>블라인드</td>
					<td>블라인드</td>
					<td>유지</td>
				</tr>
				<tr>
					<td>검수중</td>
					<td>검수중</td>
					<td>유지</td>
				</tr>
				<tr>
					<td>정상</td>
					<td>블라인드, 검수중</td>
					<td>교체</td>
				</tr>
				<tr>
					<td>검수중</td>
					<td>블라인드</td>
					<td>교체</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	import { mapState } from 'vuex';
	import ProductSelector from '@/components/ProductSelector';

	export default {
		name: 'BatchReviewProduct',
		components: {
			ProductSelector,
		},
		data() {
			return {
				word: '',
				productTitle: null,
				selectedProductId: null,
				productList: [{ title: '검색하세요', id: null }],
				selectedId: null,
				isProduct: false,
				factorList: [],
			};
		},
		computed: {
			...mapState({
				params: state => state.modal.params,
			}),
		},
		methods: {
			close() {
				this.$store.commit('modal/toggleModal', {});
			},

			async batch() {
				if (!this.selectedId) {
					alert('제품항번을 입력해주세요.');
					return;
				}

				if (!confirm('선택 리뷰를 이동하시겠습니까?')) {
					return;
				}

				try {
					const params = {
						idReviewComments: this.params.idReviewComments,
						idProduct: this.selectedId,
					};

					await this.$axiosAdmin2
						.post('/v3/api/review/move', params)
						.then(({ data }) => {
							const changeCnt = data.changeCnt;
							const holdCnt = data.holdCnt;
							const moveCnt = data.moveCnt;

							let msg = '';

							msg = '이동 : ' + moveCnt + '\n';
							msg += '교체 : ' + changeCnt + '\n';
							msg += '유지 : ' + holdCnt + '\n';

							alert(msg);

							this.params.cb();
							this.close();
						})
						.catch(err => {
							console.error(err);
							alert(
								'데이터 전송중 오류가 발생했습니다.\n계속해서 문제가 발생할 경우 관리자에게 문의하여 주시기 바랍니다.'
							);
							return;
						});
				} catch (e) {
					if (e.response.status) {
						alert('없는 제품항번입니다. 다시 검색해주세요');
						return;
					}
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.move__desc {
		margin: 18px 0;
	}

	.move__table {
		th,
		td {
			height: auto;
			padding: 8px;
			text-align: left;
		}
	}
</style>
